import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';
import { get } from 'js/utils/fetch.util';
import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

import * as helpers from './helpers';
import * as actions from '../../store/actions';
import { useGetCMSResourceURL } from 'js/hooks/useGetCMSResourceURL';

export const useGetGamesConfiguration = () => {
    const getCMSResourceURL = useGetCMSResourceURL();
    const dispatch = useDispatch();
    const lang = useUserSelector(prop('lang'));
    const requestStamp = useAppSelector(prop('requestStamp'));

    useEffect(() => {
        if (!lang) {
            return;
        }
        const requestURL = getCMSResourceURL(`/initialResources/games/${lang}`, { t: requestStamp });

        get(requestURL)
            .then(({ gamesConfiguration, gamesFeeds, ...other }) => {
                const response = {
                    ...other,
                    gamesConfiguration,
                    gamesFeeds: helpers.parseGameFeeds(gamesFeeds),
                    games: helpers.filterGames(gamesConfiguration)
                };

                dispatcher.dispatch('games:data', response);
                dispatch(actions.updateGamesData(response));
            });
    }, [dispatch, lang, requestStamp, getCMSResourceURL]);
};
